import { lazy, Suspense } from "react";
import { LanguageType } from "types/localization";
import "./styles.sass";

const LazyArrows = lazy(
  () => import("assets/icons/glory/split-arrows.svg?react"),
);

type LanguageSelectItemProps = {
  language: LanguageType;
  showArrows: boolean;
  onClick: () => void;
};

const LanguageSelectItem = ({
  language,
  showArrows,
  onClick,
}: LanguageSelectItemProps) => {
  if (!language) {
    return null;
  }

  return (
    // eslint-disable-next-line react/button-has-type, react/jsx-handler-names
    <button className="LanguageSelectItem" onClick={onClick}>
      <div className="LanguageSelectItem__flag" aria-hidden="true">
        <img src={language.img} alt={language.isoCode} />
      </div>
      <div className="LanguageSelectItem__name">{language.orig}</div>

      {showArrows && (
        <div className="LanguageSelectItem__arrows">
          <Suspense fallback="">
            <LazyArrows />
          </Suspense>
        </div>
      )}
    </button>
  );
};

export default LanguageSelectItem;
